module.exports = __webpack_public_path__ + "img/best@2x.d347ea2b.png";